import type { RouteRecordRaw } from 'vue-router';

// A2 catalog routes (post 2026-05-14 integration). Bundles route at
// /catalog/bundles/new was removed: bundle creation is now an in-place
// drawer launched from the catalog overview's multi-select toolbar.
export const routes: RouteRecordRaw[] = [
  {
    path: '/auctions/:id/catalog',
    name: 'catalog-overview',
    component: () => import('./pages/CatalogOverviewPage.vue'),
    meta: {
      requiresAdminAuth: true,
      requiredRole: 'admin',
      lifecycle: ['draft', 'published', 'open', 'closed'],
    },
  },
  {
    path: '/auctions/:id/catalog/import',
    name: 'catalog-import',
    component: () => import('./pages/BulkImportPage.vue'),
    meta: {
      requiresAdminAuth: true,
      requiredRole: 'admin',
      // Closed is excluded here as well as on the toolbar button: importing is
      // a bulk create, and a disabled button is no guard against a pasted URL.
      lifecycle: ['draft', 'published', 'open'],
    },
  },
];
